import React, {useEffect, useState} from 'react';
import cl from '../styles/CourseIdPage.module.css'
import def from '../Assets/background-login.png'
import code from "../Assets/icons/source_gray.svg";
import {useNavigate, useParams} from "react-router-dom";
import Service from "../API/Service";
import dep from "../Assets/icons/dashboard_customize.svg";
import teacher from "../Assets/icons/book.svg";
import calendar from "../Assets/icons/calendar_today.svg";
import {format, parseISO} from "date-fns";

const CourseIdPage = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const [course, setCourse] = useState({
        id: "",
        code: "",
        title: "",
        description: "",
        teacher: {
            id: "",
            name: "",
            surname: ""
        },
        department: {
            id: "",
            code: "",
            name: "",
        },
        startDate: "",
        endDate: "",
        syllabusMetadataLink: "",
        bannerMetadataLink: "",
        isActive: ""
    });

    const formatDate = (dateStr) => {
        return dateStr ? format(parseISO(dateStr), "dd.MM.yyyy") : '...';
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getById(id, "courses");
                const data = response?.data || {};

                setCourse({
                    id: data.id,
                    code: data.code,
                    title: data.title,
                    description: data.description,
                    teacher: {
                        id: data.teacher.id,
                        name: data.teacher.name,
                        surname: data.teacher.surname
                    },
                    department: {
                        id: data.department.id,
                        code: data.department.code,
                        name: data.department.name,
                    },
                    startDate: data.startDate,
                    endDate: data.endDate,
                    syllabusMetadataLink: data.syllabusMetadataLink,
                    bannerMetadataLink: data.bannerMetadataLink,
                    isActive: data.isActive
                });

            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    return (
        <div className={cl.wrap}>
            <h1>View details</h1>
            <div className={cl.content}>
                <div className={cl.thumbnail}>
                    <img src={def} alt={"foto"}/>
                </div>
                <p className={cl.courseName}>
                    {course.title}
                </p>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={code}
                            alt={"Code"}
                        />
                        Course code
                    </div>
                    {course.code}
                </div>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={dep}
                            alt={"Department"}
                        />
                        Department
                    </div>
                    {course.department.name}
                </div>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={teacher}
                            alt={"Teacher"}
                        />
                        Teacher
                    </div>
                    {course.teacher.name}
                </div>
                <div className={cl.param}>
                    <div className={cl.paramInfo}>
                        <img
                            src={calendar}
                            alt="Calendar Icon"
                        />
                        Period
                    </div>
                    {formatDate(course.startDate)} - {formatDate(course.endDate)}
                </div>
            </div>
            <p className={cl.desc}>{course.description}</p>
            <div className={cl.syllabus}>
                Course syllabus
                <button>
                    {course.syllabusMetadataLink}
                </button>
            </div>
            <button
                className={cl.back}
                onClick={() => {navigate(-1)}}
            >
                Back
            </button>
        </div>
    );
};

export default CourseIdPage;